module.exports = __webpack_public_path__ + "static/click_effectz-5830ba62a0f0c65b8674a96648dbd417.mp3";